import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\ModelNotification\CreateModelNotificationController::__invoke
* @see app/Http/Controllers/ModelNotification/CreateModelNotificationController.php
* @route '/api/model-notification'
*/
const CreateModelNotificationController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateModelNotificationController.url(options),
    method: 'post',
})

CreateModelNotificationController.definition = {
    methods: ["post"],
    url: '/api/model-notification',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\ModelNotification\CreateModelNotificationController::__invoke
* @see app/Http/Controllers/ModelNotification/CreateModelNotificationController.php
* @route '/api/model-notification'
*/
CreateModelNotificationController.url = (options?: RouteQueryOptions) => {
    return CreateModelNotificationController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ModelNotification\CreateModelNotificationController::__invoke
* @see app/Http/Controllers/ModelNotification/CreateModelNotificationController.php
* @route '/api/model-notification'
*/
CreateModelNotificationController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateModelNotificationController.url(options),
    method: 'post',
})

export default CreateModelNotificationController